export const FETCH_COUNTRY_TAX_TYPES = 'FETCH_COUNTRY_TAX_TYPES';
export const FETCH_COUNTRY_TAX_TYPES_SUCCESS = 'FETCH_COUNTRY_TAX_TYPES_SUCCESS';
export const FETCH_COUNTRY_TAX_TYPES_FAILURE = 'FETCH_COUNTRY_TAX_TYPES_FAILURE';
export const SELECT_COUNTRY_TAX_TYPE = 'SELECT_COUNTRY_TAX_TYPE';
export const FETCH_TAX_ENTRIES = 'FETCH_TAX_ENTRIES';
export const FETCH_TAX_ENTRIES_SUCCESS = 'FETCH_TAX_ENTRIES_SUCCESS';
export const FETCH_TAX_ENTRIES_FAILURE = 'FETCH_TAX_ENTRIES_FAILURE';
export const FETCH_TAX_ENTRY_DATA = 'FETCH_TAX_ENTRY_DATA';
export const FETCH_TAX_ENTRY_DATA_SUCCESS = 'FETCH_TAX_ENTRY_DATA_SUCCESS';
export const SHOW_ADD_ENTRY_MODAL = 'SHOW_ADD_ENTRY_MODAL';
export const HIDE_ADD_ENTRY_MODAL = 'HIDE_ADD_ENTRY_MODAL';
export const FETCH_SUBLEDGER_TAX_ENTRIES = 'FETCH_SUBLEDGER_TAX_ENTRIES';
export const FETCH_SUBLEDGER_TAX_ENTRIES_SUCCESS = 'FETCH_SUBLEDGER_TAX_ENTRIES_SUCCESS';
export const FETCH_PROPOSED_JOURNALS = 'FETCH_PROPOSED_JOURNALS';
export const FETCH_PROPOSED_JOURNALS_SUCCESS = 'FETCH_PROPOSED_JOURNALS_SUCCESS';
export const FETCH_PROPOSED_JOURNALS_FAILURE = 'FETCH_PROPOSED_JOURNALS_FAILURE';
export const FETCH_SUBLEDGER_GL_ACCOUNTS = 'FETCH_SUBLEDGER_GL_ACCOUNTS';
export const FETCH_SUBLEDGER_GL_ACCOUNTS_SUCCESS = 'FETCH_SUBLEDGER_GL_ACCOUNTS_SUCCESS';
export const RESET_PROPOSED_JOURNALS = 'RESET_PROPOSED_JOURNALS';
export const RESET_TAX_ENTRIES = 'RESET_TAX_ENTRIES';
export const FETCH_TAX_ENTRIES_FOR_APPROVAL = 'FETCH_TAX_ENTRIES_FOR_APPROVAL';
export const FETCH_TAX_ENTRIES_FOR_APPROVAL_SUCCESS = 'FETCH_TAX_ENTRIES_FOR_APPROVAL_SUCCESS';
export const FETCH_TAX_ENTRIES_FOR_APPROVAL_FAILURE = 'FETCH_TAX_ENTRIES_FOR_APPROVAL_FAILURE';
export const UNLOCK_TAX_ENTRIES_FOR_APPROVAL = 'UNLOCK_TAX_ENTRIES_FOR_APPROVAL';
export const SELECT_PERIOD_FROM = 'SELECT_PERIOD_FROM';
export const SELECT_PERIOD_TO = 'SELECT_PERIOD_TO';
export const FETCH_TAX_ENTRY_FOR_APPROVAL_DATA_SUCCESS = 'FETCH_TAX_ENTRY_FOR_APPROVAL_DATA_SUCCESS';
export const RESET_DATA_FOR_APPROVE_TAX_ENTRY_PAGE = 'RESET_DATA_FOR_APPROVE_TAX_ENTRY_PAGE';
export const RESET_TAX_ENTRY_FOR_APPROVAL_DATA = 'RESET_TAX_ENTRY_FOR_APPROVAL_DATA';
export const FETCH_NOTIFICATIONS = 'FETCH_NOTIFICATIONS';
export const FETCH_NOTIFICATIONS_SUCCESS = 'FETCH_NOTIFICATIONS_SUCCESS';
export const FETCH_NOTIFICATIONS_FAILURE = 'FETCH_NOTIFICATIONS_FAILURE';
export const RESET_DATA_FOR_NOTIFICATIONS_PAGE = 'RESET_DATA_FOR_NOTIFICATIONS_PAGE';
export const FETCH_PROPOSED_RECLASS_JOURNALS = 'FETCH_PROPOSED_RECLASS_JOURNALS';
export const FETCH_PROPOSED_RECLASS_JOURNALS_SUCCESS = 'FETCH_PROPOSED_RECLASS_JOURNALS_SUCCESS';
export const FETCH_PROPOSED_RECLASS_JOURNALS_FAILURE = 'FETCH_PROPOSED_RECLASS_JOURNALS_FAILURE';
export const FETCH_DIAGNOSTICS = 'FETCH_DIAGNOSTICS';
export const FETCH_DIAGNOSTICS_SUCCESS = 'FETCH_DIAGNOSTICS_SUCCESS';
export const FETCH_DIAGNOSTICS_FAILURE = 'FETCH_DIAGNOSTICS_FAILURE';

export const SUBMIT_TAX_ENTRY = 'SUBMIT_TAX_ENTRY';
export const SUBMIT_TAX_ENTRY_SUCCESS = 'SUBMIT_TAX_ENTRY_SUCCESS';
export const SUBMIT_TAX_ENTRY_FAILURE = 'SUBMIT_TAX_ENTRY_FAILURE';

export const SUBMIT_DIRECT_TAX_ENTRIES = 'SUBMIT_DIRECT_TAX_ENTRIES';
export const SUBMIT_DIRECT_TAX_ENTRIES_SUCCESS = 'SUBMIT_DIRECT_TAX_ENTRIES_SUCCESS';
export const SUBMIT_DIRECT_TAX_ENTRIES_FAILURE = 'SUBMIT_DIRECT_TAX_ENTRIES_FAILURE';

export const REVIEW_TAX_ENTRIES = 'REVIEW_TAX_ENTRIES';
export const REVIEW_TAX_ENTRIES_PROGRESS = 'REVIEW_TAX_ENTRIES_PROGRESS';
export const REVIEW_TAX_ENTRIES_SUCCESS = 'REVIEW_TAX_ENTRIES_SUCCESS';
export const REVIEW_TAX_ENTRIES_CANCELLED = 'REVIEW_TAX_ENTRIES_CANCELLED';
export const REVIEW_TAX_ENTRIES_FAILURE = 'REVIEW_TAX_ENTRIES_FAILURE';

export const FETCH_TAX_ENTRIES_TREE = 'FETCH_TAX_ENTRIES_TREE';
export const FETCH_DEFERRED_TAX_RATE = 'FETCH_DEFERRED_TAX_RATE';
export const FETCH_OBLIGATION_RATES = 'FETCH_OBLIGATION_RATES';
export const FETCH_TYPE_DESCRIPTIONS = 'FETCH_TYPE_DESCRIPTIONS';
export const FETCH_ACTIVITY_DESCRIPTIONS = 'FETCH_ACTIVITY_DESCRIPTIONS';
export const FETCH_TBE_ERRORS = 'FETCH_TBE_ERRORS';
